import css from "./memory.module.scss";

export default function MemoryAlert({ tone = "info", role, children }) {
  return (
    <div
      role={role}
      className={`${css.alert} ${tone === "danger" ? css.alertDanger : css.alertInfo}`}
    >
      {children}
    </div>
  );
}
